import moment from 'moment'
import InteractiveDayView from './InteractiveDayView'

function DayOverview({ date, resources, bookings, onSlotSelect, draftBooking, onDateChange }) {
	const formattedHeading = date?.format('dddd, MMM D, YYYY') || 'Select a date'
	const dateInputValue = date?.format('YYYY-MM-DD') || ''

	const handleShiftDay = delta => {
		if (!onDateChange) return
		const base = date?.clone() ?? moment()
		onDateChange(base.add(delta, 'day'))
	}

	const handleDateInputChange = e => {
		if (!onDateChange) return
		const nextValue = e.target.value
		if (!nextValue) return
		const nextMoment = moment(nextValue, 'YYYY-MM-DD', true)
		if (!nextMoment.isValid()) return
		if (date?.isValid?.()) {
			nextMoment.hour(date.hour()).minute(date.minute())
		}
		onDateChange(nextMoment)
	}

	return (
		<section>
			<div className="mb-3 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
				<div>
					<h3 className="text-base font-semibold text-gray-900">Day overview</h3>
					<p className="text-sm text-gray-500">Stay aware of existing bookings for the selected day.</p>
				</div>
				<div className="flex items-center gap-2 text-sm text-gray-600 font-medium">
					<button
						type="button"
						onClick={() => handleShiftDay(-1)}
						className="rounded-md border border-gray-200 px-2.5 py-1 text-gray-700 hover:bg-gray-50"
					>
						Previous
					</button>
					<input
						type="date"
						value={dateInputValue}
						onChange={handleDateInputChange}
						className="rounded-md border border-gray-300 px-3 py-1 text-gray-700 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
					/>
					<button
						type="button"
						onClick={() => handleShiftDay(1)}
						className="rounded-md border border-gray-200 px-2.5 py-1 text-gray-700 hover:bg-gray-50"
					>
						Next
					</button>
				</div>
				<div className="text-sm text-gray-600 font-medium">{formattedHeading}</div>
			</div>
			<InteractiveDayView
				resources={resources}
				bookings={bookings}
				startDate={date}
				onSlotSelect={onSlotSelect}
				draftBooking={draftBooking}
			/>
		</section>
	)
}

export default DayOverview
